 import { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "./Contact.css";

const Contact = () => {
  const formRef = useRef(null);
  const [submitState, setSubmitState] = useState({
    status: "idle",
    message: "",
  });

  const handleSubmit = (event) => {
    event.preventDefault();
    setSubmitState({
      status: "sending",
      message: "Sending your message...",
    });

    emailjs
      .sendForm(
        "service_03pjya6",
        "template_xp8ujwj",
        formRef.current,
        "ELvZTvJpFFSF7zI-e"
      )
      .then(
        () => {
          setSubmitState({
            status: "success",
            message: "Message sent. We will follow up shortly.",
          });
          formRef.current.reset();
        },
        () => {
          setSubmitState({
            status: "error",
            message: "Message failed to send. Please try again.",
          });
        }
      );
  };

  return (
    <section className="contact-section" id="contact-form">
      <div className="section-shell contact-shell">
        <div className="contact-intro">
          <span className="eyebrow">Get in touch</span>
          <h1 className="section-heading">Talk through the commercialization problem in front of you.</h1>
          <p className="section-intro">
            If you need sharper launch planning, better sales operations, or
            more useful reporting, start here. We can discuss the stage your
            team is in and where the operating friction is showing up.
          </p>

          <div className="contact-points">
            <div className="contact-point surface-card">
              <h2>Where we help most</h2>
              <p>Commercialization strategy, sales operations, reporting, analytics, and execution support.</p>
            </div>
            <div className="contact-point surface-card">
              <h2>Best time to reach out</h2>
              <p>Before a launch, during a scale-up, or when reporting and workflow complexity start to slow decisions.</p>
            </div>
          </div>
        </div>

        <div className="contact-formWrap surface-card">
          <form ref={formRef} onSubmit={handleSubmit} className="contact-form">
            <label>
              <span>Name</span>
              <input name="name" type="text" placeholder="Your name" required />
            </label>
            <label>
              <span>Email</span>
              <input name="email" type="email" placeholder="you@company.com" required />
            </label>
            <label>
              <span>Subject</span>
              <input name="subject" type="text" placeholder="How can we help?" required />
            </label>
            <label>
              <span>Message</span>
              <textarea
                name="message"
                placeholder="Tell us a bit about the product, team, or commercial challenge."
                required
              />
            </label>

            <button
              type="submit"
              className="button button--primary contact-submit"
              disabled={submitState.status === "sending"}
            >
              {submitState.status === "sending" ? "Sending..." : "Send Message"}
            </button>

            {submitState.message ? (
              <p
                className={`contact-status contact-status--${submitState.status}`}
                role="status"
              >
                {submitState.message}
              </p>
            ) : null}
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
